import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerComponent } from './shared/components/progress-spinner/progress-spinner.component';
import { GlobalProgressSpinnerService } from '@shared/services/global-progress-spinner.service';
import { NgProgressComponent } from './shared/components/ng-progress/ng-progress.component';
import { ToastModule } from 'primeng/toast';
import { NavigationService } from '@shared/services/navigate.service';
import { ProfileService } from './core/pages/profile/profile.service';
import { ChatbotComponent } from '@shared/components/chatbot/chatbot.component';
import { ChatbotService } from '@shared/components/chatbot/chatbot.service';
import { PopoverModule } from 'primeng/popover';
import { combineLatest, filter, Subscriber } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [
    RouterModule,
    CommonModule,
    ProgressSpinnerComponent,
    NgProgressComponent,
    ToastModule,
    ChatbotComponent,
    PopoverModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit, OnDestroy {
  showChatbot: boolean = false;

  private _routerSub = Subscriber.EMPTY;

  private isAnonymousSessionSub = Subscriber.EMPTY;

  readonly _globalProgressSpinnerService = inject(GlobalProgressSpinnerService);
  readonly _chatbotService = inject(ChatbotService);
  private readonly _authService = inject(AuthService);
  private readonly _navigationService = inject(NavigationService);
  private readonly _profileService = inject(ProfileService);
  private readonly _router = inject(Router);

  ngOnInit(): void {
    this._authService.refresh();
    this._navigationService.initialize();
    this._profileService.getProfile();

    this.isAnonymousSessionSub = combineLatest([
      this._authService.isAnonymousSession$,
      this._router.events.pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd)
      ),
    ]).subscribe(([isAnonymous, event]) => {
      this.showChatbot =
        !isAnonymous &&
        event.url !== '/' &&
        event.url !== '/login' &&
        event.url !== '/registration';
    });
  }

  onChatbotClick(): void {
    this._chatbotService.showChatbot();
  }

  ngOnDestroy(): void {
    this._routerSub.unsubscribe();
    this.isAnonymousSessionSub.unsubscribe();
  }
}
